import { addDays, startOfWeek } from 'date-fns'
import type { VFC } from 'react'
import * as styles from '../styles'
import { useCalendar } from '../useCalendar'

const Day: VFC<{
  date: Date
  screenreaderFormatter: Intl.DateTimeFormat
  visualFormatter: Intl.DateTimeFormat
}> = ({ date, screenreaderFormatter, visualFormatter }) => (
  <th className={styles.selectors.headerDay} scope="col">
    <span aria-hidden={true}>{visualFormatter.format(date)}</span>
    <span className="sr-only">{screenreaderFormatter.format(date)}</span>
  </th>
)
Day.displayName = 'Lapidary: Day ← WeekHeader ← Calendar'

const days = (
  referenceDate: Date,
  {
    screenreaderFormatter,
    visualFormatter,
  }: {
    screenreaderFormatter: Intl.DateTimeFormat
    visualFormatter: Intl.DateTimeFormat
  }
) => {
  return [...(Array(7) as number[])].map((_, index) => (
    <Day
      date={addDays(referenceDate, index)}
      key={index}
      screenreaderFormatter={screenreaderFormatter}
      visualFormatter={visualFormatter}
    />
  ))
}

export const WeekHeader: VFC<{
  screenreaderFormatter: Intl.DateTimeFormat
  visualFormatter: Intl.DateTimeFormat
}> = ({ screenreaderFormatter, visualFormatter }) => {
  const { weekStartsOn } = useCalendar()
  const referenceDate = startOfWeek(new Date(), { weekStartsOn })

  return (
    <thead className={styles.selectors.header}>
      <tr className={styles.selectors.week}>
        {days(referenceDate, { screenreaderFormatter, visualFormatter })}
      </tr>
    </thead>
  )
}
WeekHeader.displayName = 'Lapidary: WeekHeader ← Calendar'
